import React from "react"

const path = _ => (
  <path d="M16 0c-8.836 0-16 7.167-16 16 0 8.839 7.164 16 16 16s16-7.161 16-16c0-8.833-7.164-16-16-16zM16 7.097c1.497 0 2.71 1.213 2.71 2.71s-1.213 2.71-2.71 2.71c-1.497 0-2.71-1.213-2.71-2.71s1.213-2.71 2.71-2.71zM19.613 23.484c0 0.428-0.347 0.774-0.774 0.774h-5.677c-0.428 0-0.774-0.347-0.774-0.774v-1.548c0-0.428 0.347-0.774 0.774-0.774h0.774v-4.129h-0.774c-0.428 0-0.774-0.347-0.774-0.774v-1.548c0-0.428 0.347-0.774 0.774-0.774h4.129c0.428 0 0.774 0.347 0.774 0.774v6.452h0.774c0.428 0 0.774 0.347 0.774 0.774v1.548z"></path>
)

export default path
